<template>
  <div>
    <span v-if="!readMoreActivated">
      {{shortText}}
    </span>
    <span
      v-if="!readMoreActivated"
      @click.stop="readMoreActivated = true"
      class="primary--text"
    >
      Read more
    </span>
    <div v-if="readMoreActivated">
      {{text}}
    </div>
    <div
      v-if="readMoreActivated"
      @click.stop="readMoreActivated = false"
      class="primary--text"
    >
      Read less
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      readMoreActivated: false,
    };
  },

  props: ['text', 'shortLength'],

  computed: {
    shortText() {
      return `${this.text.slice(0, this.shortLength || 200)}...`;
    },
  },
};
</script>
